<!--
  app/components/pages/how-to-play/HtpSectionSanctions.vue
-->
<script setup lang="ts">
import { useNuxtApp } from "#imports";
import ContextLogoCrown from "~/components/context-shared/ContextLogoCrown.vue";

const { $t } = useNuxtApp();

const cards = [
  {
    key: "yellow",
    icon: "/img/htp/sanctions/yellow-card.svg",
    image: "/img/htp/sanctions/yellow-card.png",
    hoverBorder: "hover:border-yellow-400/60",
    hoverShadow: "hover:shadow-[0_0_32px_rgba(250,204,21,0.2)]",
  },
  {
    key: "red",
    icon: "/img/htp/sanctions/red-card.svg",
    image: "/img/htp/sanctions/red-card.png",
    hoverBorder: "hover:border-red-500/60",
    hoverShadow: "hover:shadow-[0_0_32px_rgba(239,68,68,0.2)]",
  },
];
</script>

<template>
  <section id="sanctions" class="scroll-mt-48">
    <div
      class="flex flex-col bigsm:flex-row bigsm:items-baseline gap-1 bigsm:gap-4 mb-6 pb-2 bigsm:border-b bigsm:border-gray-700"
    >
      <div
        class="flex items-baseline gap-3 shrink-0 border-b border-gray-700 pb-2 bigsm:pb-0 bigsm:border-none"
      >
        <span class="text-primary shrink-0 self-center"><ContextLogoCrown :width="28" :height="28" /></span>
        <h2 class="font-kings text-3xl bigsm:text-4xl uppercase">
          {{ $t("howToPlay.section.sanctions.title") }}
        </h2>
      </div>
    </div>
    <div class="grid bigsm:grid-cols-2 gap-4 bigsm:gap-6 px-4 bigsm:px-6">
      <div
        v-for="card in cards"
        :key="card.key"
        class="group bg-gray-900 border border-gray-700 rounded-lg overflow-hidden transition-all duration-300 flex flex-col sm:flex-row"
        :class="[card.hoverBorder, card.hoverShadow]"
      >
        <!-- Image: side panel on desktop only -->
        <NuxtImg
          :src="card.image"
          alt=""
          aria-hidden="true"
          width="400"
          height="346"
          format="webp"
          loading="lazy"
          class="hidden sm:block sm:w-2/5 shrink-0 object-cover transition-transform duration-500 group-hover:scale-[1.03]"
        />

        <!-- Content -->
        <div class="flex-1 min-w-0 flex flex-col divide-y divide-gray-700">
          <!-- Title + description -->
          <div class="p-4 bigsm:p-5 space-y-2 bigsm:space-y-3 flex-1">
            <div class="flex items-center gap-3">
              <img
                :src="card.icon"
                alt=""
                aria-hidden="true"
                class="w-5 h-7 shrink-0 object-contain transition-transform duration-300 group-hover:rotate-6 group-hover:scale-110"
              />
              <h3
                class="flex-1 text-base bigsm:text-lg uppercase font-semibold"
                :class="[
                  { 'text-yellow-400': card.key === 'yellow' },
                  { 'text-red-500': card.key === 'red' },
                ]"
              >
                <em>{{ $t(`howToPlay.section.sanctions.${card.key}.title`) }}</em>
              </h3>
              <!-- Mobile-only: card thumbnail to the right of the title -->
              <NuxtImg
                :src="card.image"
                alt=""
                aria-hidden="true"
                width="400"
                height="346"
                format="webp"
                loading="lazy"
                class="sm:hidden w-1/3 h-[72px] shrink-0 object-cover object-top rounded"
              />
            </div>
            <p class="text-gray-300 text-sm bigsm:text-base leading-relaxed">
              {{ $t(`howToPlay.section.sanctions.${card.key}.description`) }}
            </p>
          </div>

          <!-- Matchball -->
          <div class="px-4 bigsm:px-5 py-3 bigsm:py-4">
            <span class="text-sm uppercase text-primary block mb-1">
              {{ $t("howToPlay.section.matchball.subtitle") }}
            </span>
            <p class="text-gray-400 text-sm leading-relaxed">
              {{ $t(`howToPlay.section.sanctions.${card.key}.matchball`) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
